export const translatedVoiceoversAudios = {
  // by taskId by locale
  current: {} as Record<string, Record<string, HTMLAudioElement>>,
};
